<script>
import {onMounted, ref} from "vue";
import {useSecurityStore} from "@/stores/Security";
import {useCodificationStore} from "@/stores/Setting/Codification";
import axios from "axios";
import useTools from "@/use/Tools";

export default {
    setup() {
        const loading = ref(false);
        const securityStore = useSecurityStore();
        const codificationStore = useCodificationStore();

        const {$i18n, $router} = useTools();

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
                width: "0px"
            },
            {
                text: $i18n.t('common.module'),
                align: "start",
                sortable: true,
                value: "entity",
            },
            {
                text: $i18n.t('common.prefix'),
                align: "start",
                sortable: false,
                value: "prefix",
            },
            {
                text: $i18n.t('common.value'),
                align: "start",
                sortable: false,
                value: "value",
            },
            {
                text: $i18n.t('common.size'),
                align: "start",
                sortable: false,
                value: "size",
            },
            {
                text: $i18n.t('common.suffix'),
                align: "start",
                sortable: false,
                value: "suffix",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_GENERAL_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'codifications.edit', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/codifications').then((response) => {
                codificationStore.setCodifications(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findAll());

        return {
            loading,
            securityStore,
            codificationStore,
            headers,
            actions,
            findAll,
        }
    }
};
</script>

<template>
    <div>
        <w-app :title="$t('module.codifications')">
            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="codificationStore.codifications"
                    sort-by="id"
                >
                    <template v-slot:[`item.entity`]="{ item }">
                        <w-inline-text bold :text="$t(`codification.${item.entity}`)"/>
                    </template>
                    <template v-slot:[`item.prefix`]="{ item }">
                        <w-inline-text :text="item.prefix"/>
                    </template>
                    <template v-slot:[`item.value`]="{ item }">
                        <w-chip outlined :text="item.value"/>
                    </template>
                    <template v-slot:[`item.size`]="{ item }">
                        <w-chip outlined :text="item.size"/>
                    </template>
                    <template v-slot:[`item.suffix`]="{ item }">
                        <w-inline-text :text="item.suffix"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
